import React from 'react';
import { ContentContainer, Description, Content, Space } from './aboutElements';

const About = () => {
  return (
    <div>
      <ContentContainer>
        <Description>
          <Content>
            Jonathan Root is a London-based portrait photographer with a practice centered on the art, design, and architectural communities.<br /><br />
            Over the course of his career, he has had the opportunity to sit with many of the figures who have shaped contemporary culture, including David Hockney, Zaha Hadid, Sir Norman Foster, Philippe Starck, and Mark Rylance. His approach is largely driven by the subject and their surroundings, aiming to produce portraits that feel authentic to the individual’s own space and character.<br /><br />
            His work is represented in the permanent collection of the National Portrait Gallery, which holds his portraits of Sir David Adjaye, Gavin Turk, and Lord March, among others.<br /><br />
            He has been fortunate to receive recognition through the Taylor Wessing Photographic Portrait Prize and the John Kobal Photographic Portrait Awards. His work has also been the subject of several exhibitions, such as Sitting Pretty and The Edwardian Drape Society.<br /><br />
            Jonathan continues to work on editorial and private commissions, collaborating with creative practitioners to document their life and work.
          </Content>
        </Description>
        <Space>
        </Space>

        <Description>
          <img src='/images/about/Photographer-Jonathan-Root-retro-interiors-8-950x1425.webp' alt='Photographer Jonathan Root retro interiors' />
          <p>Jonathan Root - Chalk Farm, London</p>
        </Description>


      </ContentContainer>




    </div>
  );
};

export default About;